import { useAuthContext } from "../contexts/auth";

/**
 * Company-level feature flag from the auth context (permissions.company_features,
 * loaded at login). Defaults to false: no row, no flag object, or no auth means
 * the feature is off.
 *
 * Component-level counterpart of routes.js's PAGE_TO_COMPANY_FEATURE gate, for
 * features like Heritage that live inside shared screens rather than behind a
 * route.
 *
 * Enabling a feature requires the user to log out and back in — the flags are
 * baked into the auth context at login (same behaviour as outreach).
 */
export const useCompanyFeature = (featureKey: string): boolean => {
  const auth = useAuthContext() as
    | { company_features?: Record<string, boolean> }
    | null
    | undefined;
  return Boolean(auth?.company_features?.[featureKey]);
};
